import type { BaseUsecase } from '@usecases/base-usecase';

export interface WarmMergeTransferEventPublisher {
  publish(): Promise<void>;
}

export interface WarmMergeTransferUsecase extends BaseUsecase<void, void> {
  run(): Promise<void>;
}

export class WarmMergeTransfer implements WarmMergeTransferUsecase {
  constructor(private publisher: WarmMergeTransferEventPublisher) {}

  async run(): Promise<void> {
    await Promise.all([this.publisher.publish()]);
  }
}
